/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import flatten from 'lodash/flatten';
import qs from 'qs';
import omit from 'lodash/omit';
import { CountryFilters, NetworkingFacet, PPSSortOrder } from '../common/Constants';

const PPS_KEY = 'ppsFilterData';
const MULTILUNGUAL_NAME_KEY = 'featureFilters.multilingualNames.name';
const featureFilterPrefix = ['featureFilters', MULTILUNGUAL_NAME_KEY];
const filterTitles = { userId: 'Networking', 'featureFilters.multilingualNames.name': 'Features' };
const highestSortOrder = 100;

const convertToArray = (data) => {
  if (typeof data === 'string' && data.length) {
    return JSON.parse(data);
  }
  if (typeof data === 'object') {
    return data;
  }

  return [];
};

const constructQueryParamWithExistingQueryParams = (paramName, paramValue, currentUrlQueryParamString) => {
  const params = { ...omit(qs.parse(currentUrlQueryParamString), [paramName]), [paramName]: paramValue };
  return params;
};

const constructUrlParamsWithSelectedFilters = (facetFilters, currentUrlQueryParamString) => {
  const sanitizedParams = facetFilters.map((filterArr) => filterArr.reduce((acc, filter) => {
    const tokens = filter.split(':');
    const key = tokens[0];
    tokens.splice(0, 1);
    const val = tokens.join(':');
    const result = val.includes(': ') ? `${key}:id-${val.split(': ')[0]}` : filter;
    acc.push(result);
    return acc;
  }, []));

  const params = constructQueryParamWithExistingQueryParams('refinementList', sanitizedParams, currentUrlQueryParamString);
  return params;
};

const parseFilterJson = (data, configs) => {
  const { nestedKey } = configs;

  const recursive = (item) => {
    if (item[nestedKey] && item[nestedKey].length) {
      item[nestedKey] = convertToArray(item[nestedKey]);
      item[nestedKey]
        && item[nestedKey].forEach((subItem) => {
          subItem[nestedKey] = convertToArray(subItem[nestedKey]);
          recursive(subItem);
        });
    }
  };

  data.forEach((item) => {
    recursive(item);
  });

  return data;
};

const populateLabel = (data, configs) => {
  const { nestedKey } = configs;
  const recursive = (item) => {
    item.shortDescription = item.shortDescription || item.text;
    if (item[nestedKey] && item[nestedKey].length) {
      item[nestedKey]
        && item[nestedKey].forEach((subItem) => {
          if (subItem[nestedKey] && subItem[nestedKey].length === 0) {
            subItem.shortDescription = subItem.shortDescription || subItem.text;
          }
          recursive(subItem);
        });
    }
  };

  data.forEach((item) => {
    recursive(item);
  });
  return data;
};

// const getFilterQueries = (filterData, config) => {
//   const { id, nestedKey } = config;
//   const query = {};

//   const appendToQuery = (uniqueId, arrayValues) => {
//     query[uniqueId] = query[uniqueId] || [];
//     query[uniqueId] = query[uniqueId].concat(arrayValues);
//   };

//   const isLeaf = item =>
//     item[nestedKey].filter(i => typeof i.checked !== 'undefined').length > 0;

//   const getLeaves = (item) => {
//     const checkedLeafNodes = item[nestedKey]
//       .filter(i => i.checked)
//       .map(i => i[id]);
//     return checkedLeafNodes.length
//       ? checkedLeafNodes
//       : item[nestedKey].map(i => i[id]);
//   };

//   const getCheckedLeaves = item =>
//     item[nestedKey].filter(i => i.checked).map(i => i[id]);

//   const innerChildrenFunction = (item, uniqueId) => {
//     const hasLeadNodes = isLeaf(item);
//     if (hasLeadNodes) {
//       appendToQuery(uniqueId, getLeaves(item));
//     } else {
//       appendToQuery(uniqueId, item[nestedKey].map(i => i[id]));
//       item[nestedKey].forEach(childItem =>
//         innerChildrenFunction(childItem, uniqueId));
//     }
//   };

//   const innerSelectedFunction = (item, uniqueId) => {
//     const hasLeadNodes = isLeaf(item);
//     if (hasLeadNodes) {
//       appendToQuery(uniqueId, getLeaves(item));
//     } else if (item.selected.length > 0) {
//       appendToQuery(uniqueId, item.selected.map(i => i[id]));
//       item.selected.forEach(selectedItem =>
//         innerSelectedFunction(selectedItem, uniqueId));
//     } else {
//       appendToQuery(uniqueId, item[nestedKey].map(i => i[id]));
//       item[nestedKey].forEach(childItem =>
//         innerChildrenFunction(childItem, uniqueId));
//     }
//   };

//   const innerFunction = (item, uniqueId) => {
//     const hasLeadNodes = isLeaf(item);
//     if (hasLeadNodes) {
//       appendToQuery(uniqueId, getCheckedLeaves(item));
//     } else if (item.selected.length) {
//       appendToQuery(uniqueId, item.selected.map(i => i[id]));
//       item.selected.forEach(selectedItem =>
//         innerSelectedFunction(selectedItem, uniqueId));
//     }
//   };

//   filterData.forEach((item) => {
//     innerFunction(item, item.uniqueId);
//   });
//   return query;
// };

// const generateAlgoliaFilterQuery = (query) => {
//   const keys = Object.keys(query);
//   const data = [];
//   keys.forEach((key) => {
//     if (query[key].length) {
//       data.push(query[key]);
//     }
//   });

//   let queryString = '';
//   data.forEach((items, itemIndex) => {
//     queryString += '(';

//     items.forEach((id, childIndex) => {
//       queryString += `profileResponses.answers.id:${id}`;
//       if (childIndex !== items.length - 1) {
//         queryString += ' OR ';
//       }
//     });

//     queryString += ')';

//     if (itemIndex < data.length - 1) {
//       queryString += ' AND ';
//     }
//   });
//   return queryString;
// };

// const getAlgoliaFilterQuery = (filterData, config) => {
//   const query = getFilterQueries(filterData, config);
//   const algoliaFilterQuery = generateAlgoliaFilterQuery(query);
//   return algoliaFilterQuery;
// };

const parseAnswer = (
  question,
  parentAnswer,
  answerText,
  filterData,
  facets,
  level,
  levels,
  count
) => {
  // console.log(`parseAnswer:: question: ${question}\n parentAnswer: ${parentAnswer}\nlevel: ${level}`);
  if (level === 4) return {};
  // const levels = ['lvl0', 'lvl1', 'lvl2', 'lvl3', 'lvl4'];
  const answerLevel = `${PPS_KEY}.${question}.${levels[level]}`;
  const queryLevel = `${PPS_KEY}.${question}.${levels[level - 1]}`;
  // console.log(answerLevel);
  if (facets[answerLevel] === undefined) {
    return {
      text: answerText, queryKey: queryLevel, queryText: parentAnswer, count
    };
  }
  const answers = Object.keys(facets[answerLevel]);
  return {
    text: answerText,
    queryText: parentAnswer,
    queryKey: queryLevel,
    count,
    // eslint-disable-next-line max-len
    answers: answers
      .filter((answer) => answer.startsWith(parentAnswer))
      .map((answer) => parseAnswer(
        question,
        answer,
        answer.replace(`${parentAnswer} > `, ''),
        filterData,
        facets,
        level + 1,
        levels
      ))
  };
};

const parseQuestion = (question, filterData, facets, level, levels) => {
  // console.log(`parseQuestion:: question: ${question}\nfilterData: ${JSON.stringify(filterData)}\nlevel: ${level}`);
  if (level === 4) return {};
  // const levels = ['lvl0', 'lvl1', 'lvl2', 'lvl3', 'lvl4'];
  const answerLevel = `${PPS_KEY}.${question}.${levels[level]}`;
  const sortOrderValue = facets[`${PPS_KEY}.${question}.${PPSSortOrder}`];
  let tmpSortOrder;
  if (question === CountryFilters) {
    tmpSortOrder = highestSortOrder;
  } else {
    tmpSortOrder = sortOrderValue != null ? parseInt(Object.keys(sortOrderValue), 10) : -1;
  }
  const sortOrder = tmpSortOrder;
  // console.log(answerLevel);
  // console.log(facets, answerLevel);
  const answers = Object.keys(facets[answerLevel]);
  // console.log(answers);
  if (answers === undefined) return {};
  return {
    text: question,
    sortOrder,
    answers: answers.map((answer) => parseAnswer(
      question,
      answer,
      answer,
      filterData,
      facets,
      level + 1,
      levels,
      facets[answerLevel][answer]
    ))
  };
};

const getIndividualTypeFollowees = (followees) => followees.filter((f) => f.followeeType === 'Individual');

const parseFilterData = (facets = {}, followees = []) => {
  // console.log('input', facets);
  let filterData = [];
  const flatFilterPrefix = [];
  if (Object.keys(facets).includes(NetworkingFacet.userId)) {
    const followeeIds = {};
    const individualFollowees = getIndividualTypeFollowees(followees);
    if (individualFollowees.length > 0) {
      flatFilterPrefix.push(NetworkingFacet.userId);
      individualFollowees.forEach((f) => {
        followeeIds[f.followeeId] = 1;
      });
      facets.userId = followeeIds;
    } else {
      delete facets.userId;
    }
  } else {
    delete facets.userId;
  }
  // const { facets } = results[0];
  const ppsFilterKeys = Object.keys(facets).filter((facet) => facet.startsWith(PPS_KEY));
  let levelKeys = uniqBy(ppsFilterKeys.map((i) => {
    const c = i.split('.');
    return c[c.length - 1];
  }));
  levelKeys = levelKeys.filter((levelKey) => levelKey !== PPSSortOrder);
  // console.log('ppsFilterKeys', ppsFilterKeys);
  filterData = groupBy(
    ppsFilterKeys,
    // facet => facet.match(/ppsFilterData.([\w\s]+).lvl\d/)[1]
    (facet) => facet.split('.')[1]
  );
  const questions = Object.keys(filterData);
  // console.log('questions', questions);
  const returnedQuestions = questions
    .map((question) => parseQuestion(question, filterData, facets, 0, levelKeys));
  flatFilterPrefix.push(...featureFilterPrefix);
  const flatFilters = Object.keys(facets).filter((facet) => flatFilterPrefix.some((fp) => facet.startsWith(fp)));
  const filterDataSet = [];
  flatFilters.forEach((flatFilter) => {
    filterDataSet.push({
      text: filterTitles[flatFilter],
      facetKey: flatFilter,
      sortOrder: -1,
      answers: Object.keys(facets[flatFilter]).map((x) => ({
        text: x,
        queryText: x,
        queryKey: flatFilter,
        answers: [],
        count: facets[flatFilter][x]
      }))
    });
  });
  returnedQuestions.push(...filterDataSet);
  return returnedQuestions;
};

const getFilterQueries = (filterData, config) => {
  const { nestedKey } = config;
  const query = {};

  const isCheckedLeaf = (item) => typeof item.checked !== 'undefined' && item.checked;
  const hasInnerSelection = (item) => item.selected.length > 0 || item[nestedKey].filter((child) => isCheckedLeaf(child)).length > 0;

  const checkIfAnyChildSelected = (fil) => {
    let hasAChildSelection = false;
    fil.selected.forEach((val) => {
      if (hasInnerSelection(val)) {
        hasAChildSelection = true;
      }
    });
    fil.answers.forEach((val) => {
      if (hasInnerSelection(val) || isCheckedLeaf(val)) {
        hasAChildSelection = true;
      }
    });
    return hasAChildSelection;
  };

  const appendToQuery = (uniqueId, arrayValues) => {
    arrayValues.forEach((val) => {
      if (!checkIfAnyChildSelected(val)) {
        query[uniqueId] = query[uniqueId] || [];
        query[uniqueId] = query[uniqueId].concat([val]);
      }
    });
  };

  const appendQueryForSelectedFilter = (item, uniqueId) => {
    if (item.selected.length) {
      appendToQuery(uniqueId, item.selected);
      item.selected.forEach((selectedItem) => {
        if (hasInnerSelection(selectedItem)) {
          appendQueryForSelectedFilter(selectedItem, uniqueId);
        }
      });
    }

    item[nestedKey].forEach((child) => isCheckedLeaf(child) && appendToQuery(uniqueId, [child]));
  };

  filterData.forEach((filter) => appendQueryForSelectedFilter(filter, filter.uniqueId));
  return query;
};

const generateAlgoliaFilterQuery = (query, followees = {}) => {
  const keys = Object.keys(query);
  return flatten(keys.map((key) => {
    const queryGroup = groupBy(query[key], (q) => {
      if (q.queryKey === NetworkingFacet.userId) { return q.queryKey; }
      const queryLengthWithoutLevel = q.queryKey.length - 5;
      return q.queryKey.slice(0, queryLengthWithoutLevel);
    });
    const queryGroupKeys = Object.keys(queryGroup);
    const filterQuery = [];
    queryGroupKeys.forEach((k) => {
      const subQuery = [];
      queryGroup[k].forEach((q) => {
        if (queryGroupKeys.length === 1 && queryGroupKeys[0] === NetworkingFacet.userId) {
          const followeeIds = getIndividualTypeFollowees(followees).map((f) => f.followeeId);
          followeeIds.forEach((followee) => {
            subQuery.push(`${q.queryKey}:${followee}`);
          });
        } else if (queryGroupKeys[0] !== NetworkingFacet.userId) {
          subQuery.push(`${q.queryKey}:${q.queryText}`);
        }
      });
      filterQuery.push(subQuery);
    });
    return flatten([filterQuery]);
  }));
};

const getAlgoliaFilterQuery = (filterData, config, networkFollowees) => {
  const query = getFilterQueries(filterData, config);
  return generateAlgoliaFilterQuery(query, networkFollowees);
};

const getValueFromFacet = (id, facets) => {
  const firstLevelKeys = Object.keys(facets);
  for (let i = 0; i < firstLevelKeys.length; i++) {
    const values = facets[firstLevelKeys[i]];
    const leafKeys = Object.keys(values);
    for (let j = 0; j < leafKeys.length; j++) {
      if (leafKeys[j].startsWith(`${id}: `)) {
        return leafKeys[j];
      }
    }
  }
  return '';
};

const refineFiltersFromQueryString = (queryString, facets) => {
  const parsedQueryString = qs.parse(queryString, { arrayLimit: 5000 }).refinementList || '';
  if (!parsedQueryString) return '';
  return parsedQueryString.map((filterArr) => filterArr.reduce((acc, filter) => {
    const tokens = filter.split(':');
    if (tokens[1].startsWith('id-')) {
      const id = tokens[1].split('id-')[1];
      const value = getValueFromFacet(id, facets);
      acc.push(`${tokens[0]}:${value}`);
    } else {
      acc.push(filter);
    }
    return acc;
  }, []));
};

const markSelectedItems = (data, selectedQueryKeys) => {
  const recursive = (item) => {
    const children = item.answers;
    if (children && children.length > 0) {
      children.forEach((child) => {
        if (child.queryKey && child.queryText && selectedQueryKeys.includes(`${child.queryKey}:${child.queryText}`)) {
          child.selectedOnLoad = true;
          item.selectedOnLoad = true;
        }
        recursive(child);
      });
    }
  };

  data.forEach((item) => {
    recursive(item);
  });
  return data;
};

export default {
  parseFilterJson,
  populateLabel,
  getAlgoliaFilterQuery,
  parseFilterData,
  refineFiltersFromQueryString,
  constructUrlParamsWithSelectedFilters,
  markSelectedItems,
  constructQueryParamWithExistingQueryParams
};
